import { monthlyPickerStateToSchedule } from "./calendar-recurrence";
import {
  CALENDAR_RECURRENCE_SCHEDULE_TYPE,
  CalendarRecurrenceSchedule,
  ScheduleType,
  VisualCronSchedule,
} from "./types";

export type Frequency = "weekly" | "monthly";

type ReportRecurrenceSchedule = VisualCronSchedule | CalendarRecurrenceSchedule;

function getScheduleTime(
  schedule: ReportRecurrenceSchedule,
  defaultTime: string,
): string {
  return schedule.type === CALENDAR_RECURRENCE_SCHEDULE_TYPE
    ? schedule.schedule.time
    : (schedule.schedule?.expressions?.[0]?.time ?? defaultTime);
}

function preserveScheduleEnvelope<T extends ReportRecurrenceSchedule>(
  schedule: T,
  currentSchedule: ReportRecurrenceSchedule,
): T {
  return {
    ...schedule,
    startDate: currentSchedule.startDate,
    endDate: currentSchedule.endDate,
  };
}

export function getScheduleForFrequency({
  cachedMonthlySchedule,
  cachedWeeklySchedule,
  currentSchedule,
  defaultTime,
  nextFrequency,
}: {
  cachedMonthlySchedule: CalendarRecurrenceSchedule | null;
  cachedWeeklySchedule: VisualCronSchedule | null;
  currentSchedule: ReportRecurrenceSchedule;
  defaultTime: string;
  nextFrequency: Frequency;
}): ReportRecurrenceSchedule {
  if (nextFrequency === "monthly") {
    const nextSchedule =
      cachedMonthlySchedule ??
      monthlyPickerStateToSchedule({
        days: [new Date().getUTCDate()],
        time: getScheduleTime(currentSchedule, defaultTime),
      });

    return preserveScheduleEnvelope(nextSchedule, currentSchedule);
  }

  const nextSchedule = cachedWeeklySchedule ?? {
    type: ScheduleType.CUSTOM,
    schedule: {
      expressions: [
        {
          days: {},
          time: getScheduleTime(currentSchedule, defaultTime),
        },
      ],
    },
  };

  return preserveScheduleEnvelope(nextSchedule, currentSchedule);
}
